<template>
  <div class="bgc score">
    <Loading v-if="loading" />

    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
      <a-button
        v-if="data && data.length"
        type="primary"
        ghost
        @click="importTo"
      >
        {{ $t('exam.downbtn') + itemTitle }}
      </a-button>
    </div>

    <!-- <div class="title">
      <div class="right right_div">
        <a-button v-if="data && data.length" type="primary" @click="importTo">
          导出小分表
        </a-button>
      </div>
    </div> -->
    <div class="table_div">
      <Table
        :columns="columns"
        :pagination="false"
        :data="data"
        @change="change"
      />
      <div v-if="showChart" class="echarts">
        <div ref="chart" class="echarts_list"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import * as echarts from 'echarts'
  import Loading from '@comp/loading'
  export default {
    name: 'MinScore',
    components: {
      Table,
      Loading
    },
    props: {
      itemTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        showChart: true,
        loading: false,
        columns: [
          {
            title: this.$t('exam.minScoreColum[0]'),
            dataIndex: 'eqDisplayIndex',
            key: 'eqDisplayIndex',
            width: 100
          },
          {
            title: this.$t('exam.minScoreColum[1]'),
            dataIndex: 'eqLevelName',
            key: 'eqLevelName',
            width: 100
          },
          {
            title: `${
              this.$store.state.unionReport
                ? this.$t('exam.unionTitle')
                : this.$t('exam.grade')
            }${this.$t('exam.minScoreColum[2]')}`,
            dataIndex: 'graderate',
            key: 'graderate',
            width: 150,
            customRender: text => {
              return <span>{+text}%</span>
            }
          }
        ],
        data: [],
        orderField: 'eqDisplayIndex',
        orderType: 'asc',
        splitNum: 7,
        charts: null
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.classId || this.$route.query.seId) {
            if (this.$route.query.classId != '') {
              this.getTable(1)
            }
          }
        },
        deep: true
      }
    },
    mounted() {
      if (this.$route.query.classId != '') {
        this.getTable(1)
      }
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 30 + 24
        }
        //echarts距离处理
        data.grid = {
          top: data.legend ? top : 24,
          bottom: 28,
          left: '3.8%',
          right: '3.8%'
        }
        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            xDataDispose(item)
          })
        } else {
          xDataDispose(data.xAxis)
        }
        //x轴数据处理
        function xDataDispose(xData) {
          if (!xData.axisLabel) xData.axisLabel = {}
          xData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          xData.axisTick = {
            show: false
          }
          !xData.offset && (xData.offset = 4)
          if (!xData.axisLine) {
            xData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }

        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            data.yAxis.max = max
            data.yAxis.interval = splitVal
            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                m -75, 0
                                a 75,75 0 1,0 150,0
                                a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: '#ddeeff', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },
      findMin(array) {
        var _min = array[0] - 0 //假设最小的数就是    array[0]
        for (var i = 1; i < array.length; i++) {
          if (array[i] - 0 < _min - 0) {
            //如果其他元素大于我们假设的值，证明我们假设的值不是最小的
            _min = array[i] - 0 //重置_min的值
          }
        }
        return _min
      },
      findMax(array) {
        var max = array[0] - 0
        for (var i = 1; i < array.length; i++) {
          if (array[i] - 0 > max - 0) {
            max = array[i] - 0 //重置max的值
          }
        }
        return max
      },
      // 表格分页，排序
      change() {
        this.getTable()
      },
      getTable() {
        this.loading = true
        let columns = [
          {
            title: this.$t('exam.minScoreColum[0]'),
            dataIndex: 'eqDisplayIndex',
            key: 'eqDisplayIndex',
            fixed: 'left',
            width: 100
          },
          {
            title: this.$t('exam.minScoreColum[1]'),
            dataIndex: 'eqLevelName',
            fixed: 'left',
            key: 'eqLevelName',
            width: 100
          },
          {
            title: `${
              this.$store.state.unionReport
                ? this.$t('exam.unionTitle')
                : this.$t('exam.grade')
            }${this.$t('exam.minScoreColum[2]')}`,
            dataIndex: 'graderate',
            key: 'graderate',
            width: 150,
            customRender: text => {
              return <span>{+text}%</span>
            }
          }
        ]
        let params = {
          meId: this.$route.query.meId,
          seId: this.$route.query.seId,
          classId: this.$route.query.classId,
          orderField: this.orderField,
          orderType: this.orderType,
          campusId: this.$route.query.campusId
        }
        axios({
          url: 'questionscoreratelistv2',
          params,
          loading: false
        })
          .then(res => {
            this.loading = false

            if (res.status) {
              //图表字符串处理
              res.list &&
                (res.list = res.list.map(item => {
                  let eqLevelName = item.eqLevelName
                    ? `(${item.eqLevelName})`
                    : ''
                  item.qName = `${
                    item.eqDisplayIndex ? item.eqDisplayIndex : ''
                  }${eqLevelName}`
                  item.scoreList &&
                    (item.scoreList = item.scoreList.map(itemc => +itemc))
                  return item
                }))
              let initData = JSON.parse(JSON.stringify(res))
              this.renderEcharts(initData)

              res.mainTitle.forEach((item, i) => {
                columns.push({
                  title: item,
                  // dataIndex: 'title' + i,
                  // key: 'title' + i,
                  width: 100,
                  customRender: row => {
                    if (row['title' + i] == row.min) {
                      return (
                        <div class="score minScore">{row['title' + i]}%</div>
                      )
                    } else if (row['title' + i] == row.max) {
                      return (
                        <div class="score maxScore">{row['title' + i]}%</div>
                      )
                    } else {
                      return <div>{row['title' + i]}%</div>
                    }
                  }
                })
                this.columns = columns
              })
              res.list.forEach(ele => {
                ele.scoreList.forEach((item, i) => {
                  ele['title' + i] = item
                })
                ele['min'] = this.findMin(ele.scoreList)
                ele['max'] = this.findMax(ele.scoreList)
              })
              this.data = res.list
              this.showChart = true
            } else {
              this.data = []
              this.showChart = false
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      renderEcharts(res) {
        let titleData = res.list.map(item => item.qName)
        let xData = titleData
        this.charts = echarts.init(this.$refs.chart)
        let series = []
        let titleList = res.mainTitle.map(item => {
          let obj = {
            name: item,
            icon: 'path://M442,165 L459,165 L459,165 L459,170 C459,173.313708 456.313708,176 453,176 L436,176 L436,176 L436,171 C436,167.686292 438.686292,165 442,165 Z'
          }
          return obj
        })
        res.mainTitle.forEach((item, index) => {
          let data = []
          res.list.forEach(itemc => {
            data.push(itemc.scoreList[index])
          })

          let obj = {
            type: 'bar',
            name: item,
            barMaxWidth: '36',
            barGap: '15%',
            itemStyle: {
              normal: {
                barBorderRadius: [6, 6, 0, 0]
              }
            },
            // label: {
            //   show: true,
            //   position: 'top',
            //   distance: 12,
            //   align: 'center',
            //   verticalAlign: 'middle',
            //   rotate: 0,
            //   formatter: '{@score}%'
            // },
            data
          }
          series.push(obj)
        })

        let classLen = titleList.length
        let legendBs = Math.ceil(classLen / 10)
        let legendHeight = 350 + legendBs * 50
        // let legendTop = legendBs * 10

        this.charts.clear()
        let chartObj = {
          color: this.$store.state.echartsColor,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: '#ddeeff'
              }
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'backdrop-filter: blur(10px);max-width:300px;max-height:400px;overflow:auto;',
            formatter: params => {
              var relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${params[0].name}</div>`
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += `<div class="toolTip">${params[i].marker}${params[i].seriesName}：${params[i].value}%</div>`
              }
              return relVal
            },
            confine: true, //是否将 tooltip 框限制在图表的区域内
            enterable: true //鼠标是否可进入提示框浮层中
            // position: function(p) {
            //   // 其中p为当前鼠标的位置
            //   return [p[0] - 10, p[1] - 10]
            // },
          },
          legend: {
            data: titleList
            // padding: [0, 20]
            // top: 0
          },
          xAxis: {
            name: this.$t('exam.minScoreColum[0]'),
            type: 'category',
            data: xData,
            nameTextStyle: {
              color: '#333'
            }
          },
          yAxis: {
            name: this.$t('exam.scoreRate1'),
            nameTextStyle: {
              color: '#333'
            }
          },
          series
        }

        let yTitle = []
        series.forEach(item => {
          yTitle = yTitle.concat(item.data)
        })
        this.beforeEchart(chartObj, yTitle, { labelFc: () => '%' })
        // let oldLen = 12 / classLen
        this.cScroll(chartObj, xData, 12)

        this.charts.setOption(chartObj)
        this.charts.resize({ height: legendHeight })
      },
      importTo() {
        let { seId, classId, campusId } = this.$route.query
        let url =
          `${ApiXy.defaulteApi.host}` +
          `${ApiXy.defaulteApi.path.questionscoreratelistv2print}` +
          `?campusId=${campusId}&seId=${seId}` +
          '&classId=' +
          classId +
          '&orderField=' +
          this.orderField +
          '&orderType=' +
          this.orderType +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    background: #fff;
    .title {
      .left_div {
        margin-left: @padding-lg;
      }
      .right_div {
        margin-right: @padding-lg;
        .btn {
          margin-left: @padding-sm;
        }
      }
    }
    .table_div {
      height: calc(100% - 58px);
      padding: 0 20px;
      .echarts {
        margin-top: 32px;
        .chartText {
          display: inline-block;
          opacity: 0;
        }
      }
    }
  }
</style>
